import { z } from 'zod'

export const ADMINAGENTSPUT_CONTRACT_VERSION = '1.0.0' as const
export const adminAgentsPutResponseSchema = z.unknown()
export type AdminAgentsPutResponse = z.infer<typeof adminAgentsPutResponseSchema>
